module.exports = __webpack_public_path__ + "img/product_24.e9441ae.jpg";